import { render, staticRenderFns } from "./FeaturedRideDetail.vue?vue&type=template&id=b2c57ac0&scoped=true"
import script from "./FeaturedRideDetail.vue?vue&type=script&lang=js"
export * from "./FeaturedRideDetail.vue?vue&type=script&lang=js"
import style0 from "./FeaturedRideDetail.vue?vue&type=style&index=0&id=b2c57ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c57ac0",
  null
  
)

export default component.exports